@let isLoadingValue = loading();
@let activeThemeValue = activeTheme();

<div class="theme-options-toggle-list" [class.theme-options-toggle-list--disabled]="isLoadingValue">
  @if (isLoadingValue) {
    <kds-spinner variant="absolute" />
  }

  @for (option of themeOptions; track option.preference) {
    <div
      class="theme-options-toggle-list__option"
      role="button"
      tabindex="0"
      [class.theme-options-toggle-list__option--active]="activeThemeValue === option.preference"
      (click)="selectTheme(option.preference)"
    >
      <span>{{ option.labelTranslateKey | translate }}</span>
      @if (activeThemeValue === option.preference) {
        <i class="fa-solid fa-check fa--primary-color"></i>
      }
    </div>
  }
</div>
